import { render, staticRenderFns } from "./BackofficeBin.vue?vue&type=template&id=ee08ef4a&"
import script from "./BackofficeBin.vue?vue&type=script&lang=ts&"
export * from "./BackofficeBin.vue?vue&type=script&lang=ts&"
import style0 from "./BackofficeBin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports